import React from "react";

const HelpGeneralButton = (props) => {
  const {
    handleClick,
    buttonText,
    buttonColor,
    buttonId,
    disabled,
    otherFormatting,
  } = props;

  return (
    <>
      <button
        id={buttonId}
        className={`btn text-black ${buttonColor} ${otherFormatting} hover:bg-gray-400 rounded-md border border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-opacity-70`}
        onClick={handleClick}
        disabled={disabled}
      >
        <svg
          className="mr-1 "
          width="22"
          height="22"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM2.54503 15C2.54503 21.8787 8.12131 27.455 15 27.455C21.8787 27.455 27.455 21.8787 27.455 15C27.455 8.12131 21.8787 2.54503 15 2.54503C8.12131 2.54503 2.54503 8.12131 2.54503 15Z"
            fill="#1E1E1E"
          />
          <path
            d="M13.652 18.8864V18.7798C13.6638 17.6494 13.7822 16.7498 14.0071 16.081C14.232 15.4122 14.5516 14.8706 14.9659 14.4563C15.3802 14.042 15.8774 13.6603 16.4574 13.3111C16.8066 13.098 17.1203 12.8465 17.3984 12.5565C17.6766 12.2605 17.8956 11.9202 18.0554 11.5355C18.2211 11.1508 18.304 10.7247 18.304 10.2571C18.304 9.67708 18.1679 9.17401 17.8956 8.74787C17.6233 8.32173 17.2594 7.99325 16.8036 7.76243C16.3479 7.5316 15.8419 7.41619 15.2855 7.41619C14.8002 7.41619 14.3326 7.51681 13.8828 7.71804C13.433 7.91927 13.0572 8.23591 12.7553 8.66797C12.4535 9.10002 12.2789 9.66525 12.2315 10.3636H9.99432C10.0417 9.35748 10.3021 8.49633 10.7756 7.78018C11.255 7.06404 11.8853 6.51657 12.6665 6.13778C13.4537 5.759 14.3267 5.5696 15.2855 5.5696C16.3272 5.5696 17.2327 5.77675 18.0021 6.19105C18.7775 6.60535 19.3752 7.17353 19.7955 7.8956C20.2216 8.61766 20.4347 9.44034 20.4347 10.3636C20.4347 11.0147 20.334 11.6036 20.1328 12.1303C19.9375 12.6571 19.6534 13.1276 19.2805 13.5419C18.9136 13.9562 18.4697 14.3232 17.9489 14.6428C17.428 14.9683 17.0108 15.3116 16.6971 15.6726C16.3834 16.0277 16.1555 16.4509 16.0135 16.9421C15.8714 17.4334 15.7945 18.0459 15.7827 18.7798V18.8864H13.652ZM14.7884 24.142C14.3504 24.142 13.9746 23.9852 13.6609 23.6715C13.3472 23.3578 13.1903 22.982 13.1903 22.544C13.1903 22.1061 13.3472 21.7302 13.6609 21.4165C13.9746 21.1029 14.3504 20.946 14.7884 20.946C15.2263 20.946 15.6022 21.1029 15.9158 21.4165C16.2295 21.7302 16.3864 22.1061 16.3864 22.544C16.3864 22.834 16.3124 23.1004 16.1644 23.343C16.0224 23.5857 15.83 23.781 15.5874 23.929C15.3506 24.071 15.0843 24.142 14.7884 24.142Z"
            fill="black"
          />
        </svg>

        {buttonText}
      </button>
    </>
  );
};

export default HelpGeneralButton;

/*
default bg-gray-100
*/
